import { AIButtonStars, AICreateButton, AICreateButtonBeta, CloseIcon } from '@sketchnote/icons';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { API } from 'src/api';
import Analytics from 'src/api/services/analytics/analytics';
import { getRandomCoverImage } from 'src/components/CoverImage';
import { useLayout } from 'src/shared/hooks/use-layout';

import { SelectWorkspace } from '../SelectWorkspace/selectWorkspace';
import { PromptInput } from './promptInput';
export type WorkspaceType = {
  label: string;
  value: string;
};
export type promptType = {
  label: string;
  value: string;
  desc: string;
};

export const AiPopover = ({ level }: { level: string }): JSX.Element => {
  const router = useRouter();
  const mode = router.query.mode as string;
  const orgId = router.query.orgId as string;
  const [isOpen, setIsOpen] = useState(false);

  const [selectedPrompt, setSelectedPrompt] = useState<promptType>({
    label: '',
    value: '',
    desc: '',
  });
  const { destinationWorkspace } = useLayout();
  const [showLoader, setShowLoader] = useState(false);

  const handleAiRequest = async () => {
    setShowLoader(true);
    try {
      const res = await API.post(`/files/ai/tasks`, {
        workspace: destinationWorkspace.value,
        prompt: selectedPrompt.desc,
        coverImage: getRandomCoverImage(),
      });
      if (res.data.success) {
        Analytics.track('AI created file', { 'Prompt for file generation': selectedPrompt.desc });
        router.push(`/${mode}/${orgId}/files/${res.data.data.file}`);
      }
    } catch (e) {
      console.error('Error', e);
      return null;
    }
    setShowLoader(false);
    setIsOpen(false);
  };

  return (
    <>
      <button className="flex items-center" onClick={() => setIsOpen(true)}>
        <AICreateButtonBeta />
      </button>

      <div
        className={`fixed inset-0  ${isOpen ? 'block' : 'hidden'}`}
        onClick={() => setIsOpen(false)}
      ></div>
      <div
        className={`flex fixed bottom-0 z-50 right-2 flex-col shadow-lg w-450 rounded-lg border bg-white ${
          isOpen ? 'block' : 'hidden'
        }`}
        style={{
          height: `calc((100vh - 50px)`,
        }}
      >
        <div
          className=""
          style={{
            backgroundImage:
              'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1)), linear-gradient(90deg, rgba(61, 29, 255, 0.3) 0%, rgba(97, 71, 255, 0.3) 20%, rgba(212, 81, 255, 0.3) 50%, rgba(236, 69, 141, 0.3) 80%, rgba(255, 202, 139, 0.3) 100%)',
          }}
        >
          <div className="flex justify-between p-12">
            <div className="flex rounded-xl border px-6 bg-white py-4 items-center  mr-6">
              <AIButtonStars />
              <div className="items-center">
                <label className="ml-6 text-sm text-gray-999">Create tasks with AI</label>
                <label
                  className="border rounded-md text-xss ml-6 px-4"
                  style={{ backgroundColor: '#EDE9FE', color: '#6D28D9', borderColor: '#DDD6FE' }}
                >
                  BETA
                </label>
              </div>
              <label className="ml-6 text-sm text-gray-999 max-w-180 truncate">
                {destinationWorkspace.value !== '' ? `| ${destinationWorkspace.label}` : ''}
              </label>
            </div>
            <button aria-label="Close icon" onClick={() => setIsOpen(false)}>
              <CloseIcon className="text-gray-999" size={12} />
            </button>
          </div>

          {/* select workspace */}
          {level === 'dashboard' && (
            <div className="flex mb-22 w-full px-12 mt-15">
              <SelectWorkspace variant="white" aiFile={true} />
            </div>
          )}
        </div>
        <PromptInput
          selectedPrompt={selectedPrompt}
          setSelectedPrompt={setSelectedPrompt}
          handleAiRequest={handleAiRequest}
          showLoader={showLoader}
        />
      </div>
    </>
  );
};
